// theme.js
import { createTheme } from "@mui/material/styles";

export const brandBlue = "#1a237e";
export const brandRed = "#d50000";

const theme = createTheme({
  palette: {
    primary: { main: brandBlue },
    secondary: { main: brandRed },
  },
  typography: {
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    h1: { fontFamily: "'Montserrat', 'Roboto', sans-serif", fontWeight: 700 },
    h2: { fontFamily: "'Montserrat', 'Roboto', sans-serif", fontWeight: 700 },
    h3: { fontFamily: "'Montserrat', 'Roboto', sans-serif", fontWeight: 600 },
    h4: { fontFamily: "'Montserrat', 'Roboto', sans-serif", fontWeight: 600 },
    h5: { fontFamily: "'Montserrat', 'Roboto', sans-serif", fontWeight: 500 },
    h6: { fontFamily: "'Montserrat', 'Roboto', sans-serif", fontWeight: 500 },
    button: {
      fontFamily: "'Montserrat', 'Roboto', sans-serif",
      fontWeight: 700,
      textTransform: "none",
    },
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiLink: {
      styleOverrides: {
        root: {
          color: "#333",
          textDecoration: "none",
          "&:hover": {
            color: brandBlue,
            textDecoration: "none",
          },
        },
      },
    },
  },
});

export default theme;
